// removed by extract-text-webpack-plugin
module.exports = {"verifyAccountBannerContainer":"VerifyAccountBanner__verifyAccountBannerContainer___2p0Lh","verifyAccountBanner":"VerifyAccountBanner__verifyAccountBanner___ur-I1","verifyAccountBannerContent":"VerifyAccountBanner__verifyAccountBannerContent___26sSa","textContainer":"VerifyAccountBanner__textContainer___LbS02","text":"VerifyAccountBanner__text___2YnQb","title":"VerifyAccountBanner__title___1Gons","buttonContainer":"VerifyAccountBanner__buttonContainer___3DC-j","button":"VerifyAccountBanner__button___1qfND"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/verifyAccountBanner/VerifyAccountBanner.scss
// module id = 1988
// module chunks = 0